import React from 'react';
import styles from './events/CustomModal.module.css'
import {Modal, Backdrop, Fade} from '@material-ui/core';
import {withStyles} from '@material-ui/core/styles';
import XIcon from './svgs/XIcon';

const _styles = {
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: 'var(--white)',
    boxShadow: null,
    padding: '50px',
    maxHeight: '90%',
    overflowY: 'scroll',
    position: 'relative',
  },
};
/*
    This is an alternate to "CustomModal" which web currently uses
    This alternative exists as this is a parent wrapper and it allows the clickable
    and handlers to be set where needed with whatever data format is desired.
    CustomModal is used for events and tweaked/copied elsewhere.
    Ideally, other web modals get replaced with this.
*/
const ParentModal = ({
  classes,
  title,
  isOpen,
  modalHandler,
  children
}) => (
  <>
    <Modal
      aria-labelledby="transition-modal-title"
      className={classes.modal}
      open={isOpen}
      onClose={modalHandler}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
          timeout: 500,
        }}>
      <Fade in={isOpen}>
        <div className={classes.paper}>
          <div style={{marginBottom: 15}} className={styles.labelContainer} onClick={modalHandler}>
            <p className={`formLabel ${styles.label}`}>{title}</p>
          </div>
          <div className={styles.xIconContainer} onClick={modalHandler}>
            <XIcon width={30} height={30} tintColor={'var(--grey80)'} />
          </div>
          {children}
        </div>
      </Fade>
    </Modal>
  </>
);

export default withStyles(_styles)(ParentModal);
